import RightArrowImg from "assets/icons/down-arrow.png";
import cx from "classnames";
import { Card, FlexBox, Button } from "components";
import React, { useState } from "react";
import ROUTE_PATH from "Routes/paths";
import { ChangeHistory, EventManager, EventNames, history } from "utils";
import "./styles.scss";
import { DashboardHeaderProps } from "./types";
const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  className,
  title,
}) => {
  return (
    <FlexBox
      justifyBetween
      alignCenter
      className={cx(className, "docs-header animated fadeInUp")}
    >
      <div>
        <p className="fs-32 font-heavy">{title}</p>
      </div>
      {window.screen.width > 968 && (
        <div className="header-section">
          <FlexBox justifyBetween alignCenter>
            {ROUTE_PATH.DOCS.SDK.HOME !== history.location.pathname && (
              <p
                className="font-medium fs-16 curs-point mr-h-20"
                onClick={() => {
                  ChangeHistory("push", ROUTE_PATH.DOCS.SDK.HOME);
                }}
              >
                SDK Reference
              </p>
            )}
            {[
              ROUTE_PATH.DOCS.HOME,
              ROUTE_PATH.DOCS.SDK.HOME,
              ROUTE_PATH.DOCS.SDK.ANDROID,
              ROUTE_PATH.DOCS.SDK.FLUTTER,
              ROUTE_PATH.DOCS.SDK.IOS,
              ROUTE_PATH.DOCS.SDK.JAVASCRIPT,
            ].includes(history.location.pathname) && (
              <p
                className="font-medium fs-16 curs-point mr-h-20"
                onClick={() => {
                  ChangeHistory("push", ROUTE_PATH.DOCS.API_REFERENCE);
                }}
              >
                API Reference
              </p>
            )}
            <p
              className="font-medium fs-16 curs-point mr-h-20"
              onClick={() => {
                ChangeHistory("push", ROUTE_PATH.SAMPLES.LANDING);
              }}
            >
              OTPless.com
            </p>
            {ROUTE_PATH.DOCS.HOME !== history.location.pathname && (
              <p
                className="font-medium fs-16 curs-point mr-h-20"
                onClick={() => {
                  ChangeHistory("push", ROUTE_PATH.DOCS.HOME);
                }}
              >
                Docs
              </p>
            )}
            <Button
              text={
                window.localStorage.getItem("token") ? "Dashboard" : "Login"
              }
              variant="outline"
              className="mr-r-40 pd-v-10 pd-h-20 z-1 pos-rel fs-14"
              onClick={() => {
                const endPath = window.localStorage.getItem("token")
                  ? "ACTIVITY"
                  : "SIGNUP_LOGIN";
                // EventManager.send(
                //   EventNames.EVENTS_NAME.WEBSITE.HEADER.LOGIN_CLICK
                // );
                ChangeHistory("push", ROUTE_PATH.DASHBOARD[endPath]);
              }}
            />
          </FlexBox>
        </div>
      )}
    </FlexBox>
  );
};
export default DashboardHeader;
